var detect = require("./detect");

var replaceRefs = function replaceRefs(text, spacing, result) {
  return result.url ? " <a target=\"_blank\" href=\"".concat(result.url, "\" class=\"highlight\" title=\"").concat(result.value, "\">").concat(result.source, "</a>").concat(spacing) : " <span class=\"highlight\" title=\"".concat(result.fullValue.replace(/"/g, ""), "\">").concat(result.value, "</span>").concat(spacing);
};

var htmlize = function htmlize(text, results) {
  var replacer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : replaceRefs;
  return results.reduce(function (cur, result) {
    return cur.replace(new RegExp("(".concat(result.source, ")(\\s|\\))")), function (_, text, spacing) {
      return replacer(text, spacing, result);
    });
  }, " ".concat(text, " ")).replace(/\n/gi, "<br>");
};

var replace = function replace(text, defaultCode) {
  var results = detect(text, defaultCode);
  return htmlize(text, results).trim();
};

module.exports = replace;